import type { GenericField } from '@neo/blocks/forms/types'
import { TypeSelector } from './type-selector'
import { FileUploadWrapper } from './file-upload-wrapper'
import { WebsiteWrapper } from './website-wrapper'
import { AppSource } from './app-source'
import { KBDocumentSource, type NewKBFormValues } from '../../types'
import { dataSourceBaseSchema } from '../../config'
// Field Configuration
export const getDataSourceFields = (onClick?: () => void): GenericField<NewKBFormValues>[] => [
  {
    name: 'type',
    type: 'custom',
    component: TypeSelector,
    zodValidation: dataSourceBaseSchema.shape.type,
    eventDataExtractor: (event) => event,
  },
  {
    name: 'files',
    component: FileUploadWrapper,
    type: 'custom',
    className: 'min-h-0',
    onChangeListenTo: ['type'],
    visible: (values: NewKBFormValues) => values.type === KBDocumentSource.FILE,
    zodValidation: dataSourceBaseSchema.shape.files,
    eventDataExtractor: (event) => event,
  },
  {
    name: 'links',
    component: WebsiteWrapper,
    className: 'min-h-0 flex flex-col',
    onChangeListenTo: ['type'],
    type: 'custom',
    visible: (values: NewKBFormValues) => values.type === KBDocumentSource.URL,
    zodValidation: dataSourceBaseSchema.shape.links,
    eventDataExtractor: (event) => event,
    inputProps: (form) => ({ form, onClick }),
  },
  {
    name: 'app_data',
    component: AppSource,
    type: 'custom',
    className: 'min-h-0',
    onChangeListenTo: ['type'],
    visible: (values: NewKBFormValues) => values.type === KBDocumentSource.APP,
    zodValidation: dataSourceBaseSchema.shape.app_data,
    eventDataExtractor: (event) => event,
  },
]
